/*
 * @Author: scg
 * @Date: 2022-03-03 13:40:18
 * @LastEditTime: 2022-03-03 13:41:37
 * @LastEditors: scg
 * @Description:
 */
export default {
  baseURL: 'https://api.spylix.com/'
  // baseURL: "https://api.smallwatcher.info/",
};



// WEBPACK FOOTER //
// ./src/config/index.js